<template>
    <div>
        <el-form-item :label="data.label" style="width:90%">
        <el-col :span="23">
            <el-input :disabled="disabled"
            :class="(verifyFields (data, validation)
             || verifyEmail (data)
             || verifyNumbers (data)
             || verifyPasswords(data))
             && !disabled ? 'input-warning':''" :type="data.type"
            :maxlength="data.max"
            @input="data.type !== 'password' && saveDataToLocalStorage(data.model, data.name)"
            show-word-limit v-model="data.model"
            style="margin-left:4%"/>
        </el-col>
        <el-alert v-if="verifyFields (data, validation) && !disabled" :title="`Falta completar: ${data.label}`" type="error" class="message-warning" :closable="false"/>
        <el-alert v-if="verifyEmail (data)" :title="`Ingresar Email valido`" type="error" class="message-warning" :closable="false"/>
        <el-alert v-if="verifyNumbers (data)" :title="`Ingresar ${data.max} valores numericos`" type="error" class="message-warning" :closable="false"/>
        <el-alert v-if="verifyPasswordLength (data)" :title="`Las contraseñas deben tener mas de 6 caracteres`" type="error" class="message-warning" :closable="false"/>
        <el-alert v-if="verifyPasswords (data)" :title="`Las contraseñas no coinciden`" type="error" class="message-warning" :closable="false"/>
        </el-form-item>
    </div>
</template>

<script>
import { verifyFields, persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'
export default {
  data () {
    return {
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    formattedData () {
      const data = this.data.model
      if (data.length === 11) {
        return `${data.slice(0, 2)}-${data.slice(2, 5)}-${data.slice(5)}`
      }
      return data
    }
  },
  methods: {
    verifyFields,
    saveDataToLocalStorage,
    persistToNewProviderStorage,
    verifyEmail (data) {
      const regex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/
      return (!regex.test(data.model) && data.model.length > 0 && data.validate === 'email' && this.validation === false)
    },
    verifyNumbers (data) {
      const regex = /^[0-9]+$/
      return ((!regex.test(data.model) || data.model.length < data.max) && data.model.length > 0 && data.validate === 'onlyNumbers' && this.validation === false)
    },
    verifyPasswords (data) {
      return (data.validate === 'repeated-password' && !data.samePassword && this.validation === false && data.model.length > 0)
    },
    verifyPasswordLength (data) {
      return (data.validate === 'password' && data.model.length < 6 && this.validation === false && data.model.length > 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SimpleInput.vue?a9f8e658